import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";

export default function PaymentCancel() {
  const { user } = useAuth();
  const paid = user?.plan && user.plan !== "free";
  return (
    <div className="min-h-screen paper-noise flex items-center justify-center px-6">
      <div className="max-w-lg w-full border border-border bg-background p-10" data-testid="payment-cancel-card">
        <div className="font-mono-label text-muted-foreground mb-2">Checkout cancelled</div>
        <h1 className="font-serif-display text-4xl tracking-tight mb-3">No charge was made.</h1>
        <p className="text-muted-foreground mb-8">
          {paid ? `Changed your mind? You're still on the ${user.plan} plan, nothing about it has changed.` : "Changed your mind? Your free account still works. Upgrade whenever you're ready."}
        </p>
        <div className="flex gap-3">
          <Link to="/#pricing" data-testid="payment-cancel-pricing"><Button className="rounded-sm bg-foreground text-background hover:bg-primary btn-invert">See plans</Button></Link>
          <Link to="/app"><Button variant="outline" className="rounded-sm">Library</Button></Link>
        </div>
      </div>
    </div>
  );
}
